<template>
  <ion-modal
      :is-open="showModal"
      :backdrop-dismiss="false"
      :swipe-to-close="false"
      :css-class="['auto-height blurred']">
    <div class="monitoring-error-modal ion-no-padding">
      <ion-row class="ion-no-padding">
        <ion-col class="modal-content">
          <ion-row class="modal-icon">
            <img class="icon" v-if="error_code=='no_face_detected'" src="@/assets/icons/no-face.svg"></img>
            <img class="icon" v-else-if="error_code=='multiple_face_detected'"
                 src="@/assets/icons/multiple-face.svg"></img>
            <div v-else class="icon warning--unfilled"/>
          </ion-row>
          <ion-row class="modal-message">
            <html-content :content="message" text-align="center"/>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="modal-actions">

        <ion-button class="modal-close-button" @click="closeModal" :disabled="isUploadingImage || !faceDetected">
          <span v-if="isUploadingImage"><ion-img :src="BASE_URL+'static/images/loading-spinner.svg'"
                                                 class="loading-spinner"></ion-img></span>
          <span v-else>{{ state.language_set['link_continue'] }}</span>
        </ion-button>
      </ion-row>
    </div>
  </ion-modal>
</template>

<script setup>
import {computed, getCurrentInstance, reactive} from 'vue';
import {useStore} from 'vuex';
import {IonButton, IonCol, IonImg, IonModal, IonRow} from '@ionic/vue';
import HtmlContent from '@/components/html/HtmlContent.vue';
import constant from "@/constant";


const store = useStore();
const state = reactive({
  language_set: store.getters.languageSet,
  test_settings: store.getters.testSettings
});

const isUploadingImage = computed(() => {
  return store.state.Monitoring.isUploadingImage
})

const error_code = computed(() => {
  let code = store.state.Monitoring.error?.error_code;
  return code;
})


const message = computed(() => {

      let text = "";
      switch (error_code.value) {
        case "test_error_alert_detected_you_left_test":
          text = "[b]" + state.language_set[error_code.value] + "[/b]";
          break;
        case "no_face_detected":
        case "multiple_face_detected":
          text = "[b]" + state.language_set[error_code.value] + "[/b]\n"
              + state.language_set[error_code.value + "_sub_msg"]
          break;
        default:
          text = "[b]" + state.language_set["test_error_alert_detected_you_left_test"] + "[/b]";
          break;
      }

      return text;
    }
);


const showModal = computed(
    () => {
      return store.getters.testState === constant.STATUS_TEST_IN_PROGRESS && store.getters['Monitoring/isMonitoringHalted'];
    }
);


const BASE_URL = process.env.BASE_URL;

const instance = getCurrentInstance();
const globalEmitter = instance.appContext.config.globalProperties.$globalEmitter;

const faceDetected = computed(() => {

      if (state.test_settings.proctor_camera_mode === false) {
        return true;
      } else {
        return store.getters['Monitoring/numberOfFaceDetected'] === 1;
      }
    }
)
const closeModal = () => {
  store.dispatch('Monitoring/unHaltMonitoring', null, {
    root: true
  });

  // console.debug('error modal start browser monitoring')
  globalEmitter.emit('start-browser-monitoring');
}

</script>

<style lang="scss" scoped>
ion-modal.blurred {
  backdrop-filter: blur(10px);
}

ion-modal.auto-height {
  --height: auto;
}

ion-modal.auto-height .ion-page {
  position: relative;
  display: block;
  contain: content;
}

ion-modal.auto-height .ion-page .inner-content {
  max-height: 80vh;
  overflow: auto;
}

.modal-content {
  background-color: variables.$color-yellow-bg !important;
}

.modal-icon .icon {
  border: 0;
  width: 48px;
  height: 48px;
  margin: 48.5px auto auto;
  background-size: 48px;
}

.modal-message {
  min-width: fit-content;
  max-width: 399px;
  margin: 36px auto;
  color: variables.$text-color-primary;
}

.modal-actions {
  background-color: variables.$color-white;
  height: 84px;
  padding-top: 20px;
  padding-bottom: 16px;
}

.modal-close-button {
  margin: auto;
  --background: variables.$color-white;
  border: 1px solid #CCD3DD;
  border-radius: 4px;
  --color: #282B30;
  --background-hover: #454F59;
}

.loading-spinner {
  height: 40px;
}
</style>